import type { JSX } from "react";
// Code-keyed React component map for integration settings cards.
//
// Each integration ships its own card component and registers it here by
// `code`. The Settings → Integrations page picks the right component
// from the row's `code`. An unknown code falls back to a generic card.

import type { IntegrationCode } from "@finance-os/shared-types/integrations";
import type { IntegrationPublic } from "../api.js";

export interface IntegrationCardProps {
  row: IntegrationPublic;
  onChanged: () => void;
}

type AnyCardComponent = (props: IntegrationCardProps) => JSX.Element;

const cards: Record<string, AnyCardComponent> = {};

export function registerIntegrationCard(code: IntegrationCode, Component: AnyCardComponent): void {
  cards[code] = Component;
}

export function getIntegrationCard(code: string): AnyCardComponent | undefined {
  return cards[code];
}
